export default __webpack_public_path__ + "static/media/33.f214b02d.png";